// extracted by mini-css-extract-plugin
export default {"form-tel":"AddCarRepair_form-tel__kMQ7y"};